<template>
  <div class="text-center allbutton">
    <button class="px-2 searchmap ma-1" @click="gotomap">{{ $t("SearchMap") }}</button>
  <button class="px-2 searchmap ma-1" @click="Addrequest">{{ $t("Real_request") }}</button>
  <button class="px-2 searchmap ma-1" @click="Addoffer">{{ $t("Real_offer") }}</button>

  </div>
 
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    gotomap(){
        this.$router.push({name:'Map'})
    },
    Addrequest(){
        this.$router.push({name:'Addrequest'})
    },
    Addoffer(){
        this.$router.push({name:'Addoffer'})
    }
  },
};
</script>
<style lang="scss" scoped>

.allbutton .searchmap{
  border: 1px solid #0074c7;;
   background-color: #0074c7;
   border-radius: 6px;
   font-weight: 500;
   height: 40px;
   width: 120px;
    color: white;
}
.allbutton .searchmap:hover{
  background-color: transparent;
  color: #0074c7;
}
</style>
